export class ArrayX {
  constructor(array) {
    this.array = array;
  }

  length() {
    return this.array.length;
  }

  contains(obj) {
    var i, l = this.array.length;
    for (i = 0; i < l; i++) {
      if (this.array[i] === obj) return true;
    }
    return false;
  }

  last() {
    return this.array[this.array.length - 1];
  }

  lastOrDefault() {
    if (this.array.length == 0)
      return null;
    return this.array[this.array.length - 1];
  }

  first() {
    return this.array[0];
  }

  firstOrDefault() {
    if (this.length == 0)
      return null;
    return this[0];
  }

  remove(obj) {
    var i, l = this.array.length;
    for (i = 0; i < l; i++)
    {
      if (this.array[i] === obj) {
        this.array.splice(i, 1);
      }
    }
  }

  add(obj) {
    this.array.push(obj);
  }

  sortBy(predicate, descending) {
    return this.array.sort((obja,objb)=> {
      var a = predicate(obja);
      var b = predicate(objb);
      if (descending)
      {
        var c=a;
        a=b;
        b=c;
      }
      switch (typeof a) {
        case "string":
          return a.localeCompare(b); // .toLowerCase();
        default:
          if (a < b)
            return -1;
          else if (a==b)
            return 0;
          else
            return 1;
      }
    });
  }
}


// Array.remove(obj)
// Array.prototype.remove = Array.prototype.remove || function(obj)
// {
//   var i, l = this.length;
//   for (i = 0; i < l; i++)
//   {
//     if (this[i] === obj) {
//       this.splice(i, 1);
//       return obj;
//     }
//   }
//   return null;
// };



// Array.distinct()
// Array.prototype.distinct = Array.prototype.distinct || function(){
//   return this.filter((elem, pos, arr) => arr.indexOf(elem) === pos);
// };

// Array.clear()
// Array.prototype.clear = Array.prototype.clear || function(){
//   return this.splice(0);
// };

// Array.findIndex(x=>{...})
// if (!Array.prototype.findIndex) {
//   Object.defineProperty(Array.prototype, 'findIndex', {
//     value: function(predicate) {
//       // 1. Let O be ? ToObject(this value).
//       if (this == null) {
//         throw new TypeError('"this" is null or not defined');
//       }
//
//       var o = Object(this);
//
//       // 2. Let len be ? ToLength(? Get(O, "length")).
//       var len = o.length >>> 0;
//
//       // 3. If IsCallable(predicate) is false, throw a TypeError exception.
//       if (typeof predicate !== 'function') {
//         throw new TypeError('predicate must be a function');
//       }
//
//       // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
//       var thisArg = arguments[1];
//
//       // 5. Let k be 0.
//       var k = 0;
//
//       // 6. Repeat, while k < len
//       while (k < len) {
//         // a. Let Pk be ! ToString(k).
//         // b. Let kValue be ? Get(O, Pk).
//         // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
//         // d. If testResult is true, return k.
//         var kValue = o[k];
//         if (predicate.call(thisArg, kValue, k, o)) {
//           return k;
//         }
//         // e. Increase k by 1.
//         k++;
//       }
//
//       // 7. Return -1.
//       return -1;
//     }
//   });
// }

// Array.prototype.sortBy = Array.prototype.sortBy || function(predicate, descending) {
//   this.sort((obja,objb)=> {
//     var a = predicate(obja);
//     var b = predicate(objb);
//     if (descending)
//     {
//       var c=a;
//       a=b;
//       b=c;
//     }
//     switch (typeof a) {
//       case "string":
//         return a.localeCompare(b); // .toLowerCase();
//       default:
//         if (a < b)
//           return -1;
//         else if (a==b)
//           return 0;
//         else
//           return 1;
//     }
//   });
//   return this;
// };

//
// Array.prototype.sortByDescending = Array.prototype.sortByDescending || function(predicate) {
//   this.sortBy(predicate, true);
//   return this;
// }
//
// Array.prototype.maxBy=Array.prototype.maxBy || function(predicate) {
//     return this.reduce((prev, current) => (predicate(prev) > predicate(current)) ? prev : current);
// }
//
// Array.prototype.minBy=Array.prototype.minBy || function(predicate) {
//     return this.reduce((prev, current) => (predicate(prev) < predicate(current)) ? prev : current);
// }

// Object.getPairs()
/// Return array of key-value-pairs for an object
// Object.defineProperty(Object.prototype, 'getPairs', {
//   value: function() {
//     return Object.keys(this).map(k=>{return {key:k, value:this[k]}});
//   },
//   enumerable: false, // make sure enumerating over any object doesn't return this function
// });

// Object.eachPair((k,v)=>{...})
/// Call given function for every key-value-pair
// Object.defineProperty(Object.prototype, 'eachPair', {
//   value: function(predicate) {
//     return Object.keys(this).forEach(k=> predicate(k, this[k]));
//   },
//   enumerable: false, // make sure enumerating over any object doesn't return this function
// });